import {API_URL, apiPost} from '../api'

export const createBadge = async (data: any) => {
    return await apiPost(API_URL, 'admin/badges', data)
}
